import React, { useEffect, useRef, useState } from 'react';
import './support.css';

function ChatWidget() {
  const [open, setOpen] = useState(false);
  const [messages, setMessages] = useState(() => {
    try {
      const raw = localStorage.getItem('support_chat');
      return raw ? JSON.parse(raw) : [];
    } catch {
      return [];
    } finally {
    }
  });
  const [input, setInput] = useState('');
  const messagesRef = useRef(null);

  useEffect(() => {
    localStorage.setItem('support_chat', JSON.stringify(messages));
    if (messagesRef.current) {
      messagesRef.current.scrollTop = messagesRef.current.scrollHeight;
    }
  }, [messages]);

  const toggle = () => setOpen((v) => !v);

  const send = async (text) => {
    if (!text.trim()) return;
    const userMsg = { id: Date.now(), sender: 'user', text };
    setMessages((m) => [...m, userMsg]);
    setInput('');

    // Simulate a simple support reply. Replace this with a real API call.
    setTimeout(() => {
      const reply = {
        id: Date.now() + 1,
        sender: 'support',
        text: `Thanks — we received: "${text.slice(0, 120)}". We'll follow up soon.`,
      };
      setMessages((m) => [...m, reply]);
    }, 800);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    send(input);
  };

  return (
    <div className="support-widget">
      <button className="support-toggle" onClick={toggle} aria-expanded={open}>
        {open ? 'Close' : 'Support'}
      </button>

      {open && (
        <div className="support-panel chat" role="dialog" aria-label="Support chat">
          <div className="chat-header">
            <h4>Support Chat</h4>
            <div className="status">Online</div>
          </div>

          <div className="chat-messages" ref={messagesRef}>
            {messages.length === 0 && <div className="empty">Start the conversation — say hi!</div>}
            {messages.map((m) => (
              <div key={m.id} className={`msg ${m.sender}`}>
                <div className="bubble">{m.text}</div>
              </div>
            ))}
          </div>

          <form className="chat-input" onSubmit={handleSubmit}>
            <input
              value={input}
              onChange={(e) => setInput(e.target.value)}
              placeholder="Type a message..."
              aria-label="Message"
            />
            <button className="primary-btn" type="submit">Send</button>
          </form>
        </div>
      )}
    </div>
  );
}

function Support() {
  return (
    <main className="page">
      <section className="hero">
        <p className="eyebrow">Support</p>
        <h1>Help & Support</h1>
        <p>Use the chat widget to talk with our support team.</p>
      </section>

      <ChatWidget />
    </main>
  );
}

export default Support;
